import React from 'react';
import { Box } from '@theme-ui/components';

const PlusMinusIcon = ({ isActive }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '25px',
        height: '25px',
        minWidth: '10px',
        minHeight: '10px',
        '&::before, &::after': {
          content: '""',
          position: 'absolute',
          backgroundColor: 'white',
          transition: 'transform 0.3s ease',
        },
        '&::before': {
          top: '50%',
          left: '0',
          width: '100%',
          height: '3px',
          transform: isActive ? 'rotate(0deg)' : 'rotate(90deg)',
        },
        '&::after': {
          top: '50%',
          left: '0',
          width: '100%',
          height: '3px',
        },
      }}
    />
  );
};

export default PlusMinusIcon;
